import { createDynamicThunk } from ".";

// export const fetchFeedbackRequestsThunk = createDynamicThunk({
//   typePrefix: "FeedbackRequests/fetchFeedbackRequestsThunk",
//   endpoint: "/feedback-requests/findAll",
//   method: "POST",
// });

export const fetchFeedbackRequestsThunk = createDynamicThunk({
  typePrefix: "feedback-requests/fetchFeedbackRequestsThunk",
  useHandleSearch: true,
});

export const feedbackRequestSurveyPreviewThunk = createDynamicThunk({
  typePrefix: "feedbackRequestSurveyPreviewThunk",
  endpoint: "/feedback-requests/survey/preview",
  method: "POST",  
});

export const updateSurveyThunk = createDynamicThunk({
  typePrefix: "updateSurveyThunk",
  endpoint: "/feedback-requests/survey",
  method: "PUT",  
});
export const feedbackRequestsPreviewThunk = createDynamicThunk({
  typePrefix: "/feedbackRequestsPreviewThunk",
  endpoint: "/feedback-requests/preview",
  method: "GET",
});

export const feedbackRequestsSurveyDetailThunk = createDynamicThunk({
  typePrefix: "/feedback-requests/feedbackRequestsSurveyDetailThunk",
  endpoint: "/feedback-requests/survey",
  method: "GET",
});